import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { DropDownList } from "../Components/DropDownList";
import { CoordsButton } from "../Components/CoordsButton";
import FileDownloadTwoToneIcon from "@mui/icons-material/FileDownloadTwoTone";
import { useState } from "react";
import { addEspaceCharacters, config, constantes, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { useLocation } from "react-router-dom";
import { LoaderBox } from "../Components/LoaderBox";

function SeguimientoEditar() {
  const { state } = useLocation();
  const { id } = state;
  const [coords, setCoords] = useState();
  const [evidencias, setEvidencias] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [descripcion, setDescripcion] = useState("");
  const [isLoading, setLoading] = useState(true);
  const [mes, setMes] = useState();
  const [openDialog, setOpenDialog] = useState(false);
  const { user } = useAuth();
  const [dialog, setDialog] = useState({});
  const [seguimiento, setSeguimiento] = useState({});

  if (isLoading) {
    instance
      .get(`/seguimiento/getById/${id}`)
      .then((res) => {
        const { data } = res;
        setSeguimiento(data);
        setMes({ Id: data.mesId, Nombre: "" });
        setUnidades(
          data.reportado !== null
            ? data.reportado.split(";|||//|||;").map((item) => {
                const unidad = item.split(";//|||//;");
                return {
                  categoria: unidad[0],
                  unidad: unidad[1],
                  reportado: unidad[2],
                  categoriaId: unidad[3],
                  unidadId: unidad[4],
                };
              })
            : []
        );
        setEvidencias(
          data.evidencias !== null
            ? data.evidencias.split(";|||//|||;").map((item) => {
                const evidencia = item.split(";//|||//;");
                return {
                  descripcion: evidencia[0],
                  evidencia: evidencia[1],
                  tipoEvidencia: evidencia[2],
                  evidenciaId: evidencia[3],
                  tipoEvidenciaId: evidencia[4],
                };
              })
            : []
        );
        setDescripcion(data.descripcion);
        setCoords(data.coordenadas);
      })
      .catch((err) => {
        console.log(err);
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }
  function changeUnidades(index, e) {
    unidades[index].reportado = e.target.value;
  }

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setSeguimiento({ ...seguimiento, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      seguimiento: id,
      id: user.id,
      mes: mes.Id === "" ? seguimiento.mesId : mes.Id,
      ejecutado: info.ejecutado.value,
      coordenadas: addEspaceCharacters(coords),
      unidades: unidades,
      evidencias: evidencias,
      descripcion: addEspaceCharacters(descripcion),
    };
    instance
      .put("seguimiento/", form)
      .then((res) => {
        setDialog({
          title: "Operación exitosa",
          text: "El seguimiento ha sido actualizado exitosamente.",
          redirect: true,
          page: "/Seguimientos",
          pageState: { id: seguimiento.actividad },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        maxWidth="lg"
        sx={{ border: { xs: "0", sm: "1px solid #000" }, mt: 2 }}
      >
        <Grid
          container
          spacing={3}
          padding={2}
          rowSpacing={1}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid item xs={12} sm={6}>
            <DropDownList
              required
              title="Mes de ingreso"
              endpoint={`/seguimiento/getRegisteredMonths_Actual/${seguimiento.actividad}/${seguimiento.mesId}`}
              selectedItem={mes}
              setSelectedItem={setMes}
              selected={seguimiento.mesId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="ejecutado"
              name="ejecutado"
              label="Ejecutado en el mes"
              type="number"
              inputProps={{
                step: constantes.decimales_dinero,
                min: 0,
                style: { textAlign: "right" },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">Q</InputAdornment>
                ),
              }}
              value={seguimiento.ejecutado}
              onChange={handleInputChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="descripcion"
              label="Descripción"
              name="descripcion"
              value={descripcion}
              multiline
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="coordenadas"
              label="Coordenadas"
              name="coordenadas"
              value={coords}
              InputLabelProps={{ shrink: true }}
              onChange={(e) => setCoords(e.target.value)}
            />
            <CoordsButton
              title="Obtener ubicación actual"
              color="primary"
              output={setCoords}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ margin: 0 }} component="p">
              Reporte de unidades
            </Typography>
            <Divider />
            {unidades.map(function (item, index) {
              return (
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  type="number"
                  id={"unidad" + index}
                  name={"unidad" + index}
                  label={item.unidad}
                  InputLabelProps={{ shrink: true }}
                  key={index}
                  variant="standard"
                  size="small"
                  inputProps={{
                    step: constantes.decimales_unidades,
                    min: 0,
                    style: { textAlign: "right" },
                  }}
                  defaultValue={item.reportado}
                  onChange={(e) => changeUnidades(index, e)}
                />
              );
            })}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Typography sx={{ margin: 0 }} component="p">
              Evidencias
            </Typography>
            <Box sx={{ border: "1px solid rgba(0, 0, 0, 0.12)" }} padding={1}>
              {evidencias.map((item, index) => {
                return (
                  <>
                    <Grid
                      container
                      sx={{ display: "flex", flexDirection: "row" }}
                    >
                      <Grid item xs={6}>
                        <Typography variant="h8">
                          <b>Tipo de evidencia: </b>
                          {item.tipoEvidencia}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "end",
                          }}
                        >
                          <Link
                            href={config.evidencias_url + item.evidencia}
                            target="_blank"
                          >
                            <IconButton size="small">
                              <FileDownloadTwoToneIcon /> Ver{" "}
                              {item.tipoEvidencia}
                            </IconButton>
                          </Link>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          label="Descripción de la evidencia"
                          defaultValue={item.descripcion}
                          onChange={(e) =>
                            (evidencias[index] = {
                              ...evidencias[index],
                              descripcion: addEspaceCharacters(e.target.value),
                            })
                          }
                        />
                      </Grid>
                    </Grid>
                    <Divider />
                  </>
                );
              })}
            </Box>
          </Grid>
          <Grid
            item
            xs={12}
            sx={{
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
            }}
          >
            <Box>
              <Button
                type="submit"
                variant="contained"
                color="success"
                sx={{ mt: 3, mb: 2 }}
                padding={1}
              >
                Actualizar
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { SeguimientoEditar };
